import { Container, Wrapper } from './AdditionalHighlights.styles';
import useGetAdditionalHighlights from './useGetAdditionalHighlights';

export default function AdditionalHighlights() {
  const additionalHighlights = useGetAdditionalHighlights();
  const highlightCount = additionalHighlights.length;
  const show = highlightCount > 0;

  return show ? (
    <Container>
      <Wrapper>
        {additionalHighlights.map(highlight => {
          const { title, iconSrc } = highlight;

          return (
            <div
              className="flex w-full  items-center gap-xl py-32 first:pt-0 last:pb-0  m:flex-col m:justify-center m:gap-md m:px-4xl m:py-0 m:first:pl-0 m:last:pr-0"
              key={title}
            >
              <img
                alt={title}
                src={`${process.env.CVNA_APP_CDN_ASSETS_PATH}${iconSrc}`}
                className="h-32 w-32"
              />
              <p className="text-center tl-header-s md:whitespace-nowrap">
                {title}
              </p>
            </div>
          );
        })}
      </Wrapper>
    </Container>
  ) : null;
}
